import React from 'react';

import PublicLayout from '../../components/universal/public-layout'
import Header from '../../components/universal/public-navigation'
import NotFoundContent from '../../components/public/not-found'
import Footer from '../../components/universal/public-footer'

const NotFoundPage = () => {
    return(
        <PublicLayout Header={() => <Header light={true}/>} Content={() => <NotFoundContent/>} Footer={() => <Footer/>}/>
    )
}

export default NotFoundPage;
